import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function VoucherBasicInfoComponent({
  handleInnerFormChange, selectedVouchers, voucherTransactionTypeList,
  voucherSourceOfPaymentList, organizationUnitsList, ledgersList, paymentTransactionTypeList,
  bankConfigurationsList, paymentReferanceTypeList, supplierNameList
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Paid Date"
              name="PaidDateOnUtc"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PaidDateOnUtc'
                )
              }}
              type="date"
              value={selectedVouchers?.PaidDateOnUtc}
            />
            <InputContainer
              label="Voucher Transaction Type"
              labelField="Text"
              list={voucherTransactionTypeList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VoucherTransactionTypeId'
                )
              }}
              optionName='Choose Transaction Type'
              type="select"
              value={selectedVouchers?.VoucherTransactionTypeId}
              valueField="Value"
            />
            {selectedVouchers?.VoucherTransactionTypeId === 30 && (
              <InputContainer
                label="Payment Referance Type"
                labelField="Text"
                list={paymentReferanceTypeList}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'PaymentReferanceType'
                  );
                }}
                optionName='Choose Payment Referance Type'
                type="select"
                value={selectedVouchers?.PaymentReferanceType}
                valueField="Value"
              />
            )}
            <InputContainer
              label="Voucher Source Of Payment"
              labelField="Text"
              list={voucherSourceOfPaymentList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VoucherSourceOfPaymentId'
                )
              }}
              optionName='Choose Source Of Payment'
              type="select"
              value={selectedVouchers?.VoucherSourceOfPaymentId}
              valueField="Value"
            />
            {selectedVouchers?.VoucherSourceOfPaymentId === 20 && (
              <InputContainer
                label="Payment Transaction Type"
                labelField="Text"
                list={paymentTransactionTypeList}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'PaymentTransactionTypeId'
                  );
                }}
                optionName='Choose Payment Transaction Type'
                type="select"
                value={selectedVouchers?.PaymentTransactionTypeId}
                valueField="Value"
              />
            )}
            {selectedVouchers?.PaymentTransactionTypeId === 30 && (
              <InputContainer
                label="Bank Configuration"
                labelField="ChequeBookName"
                list={bankConfigurationsList}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'BankConfigurationId'
                  );
                }}
                optionName='Choose Bank Configuration'
                type="select"
                value={selectedVouchers?.BankConfigurationId}
                valueField="Id"
              />
            )}
            {selectedVouchers?.PaymentTransactionTypeId === 30 && (
              <InputContainer
                label="Cheque Number"
                labelField="ChequeNumber"
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'ChequeNumber'
                  );
                }}
                type="text"
                value={selectedVouchers?.ChequeNumber}
              />
            )}
            <InputContainer
              label="Organization Unit"
              labelField="OrganizationUnitInfo.Name"
              list={organizationUnitsList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'OrganizationUnitId'
                )
              }}
              optionName='Choose Organization Unit'
              type="select"
              value={selectedVouchers?.OrganizationUnitId}
              valueField="OrganizationUnitInfo.Id"
            />
            <InputContainer
              label="Ledger Name"
              labelField="LedgerName"
              list={ledgersList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'LedgerId'
                )
              }}
              optionName='Choose Ledger Name'
              type="select"
              value={selectedVouchers?.LedgerId}
              valueField="LedgerId"
            />
            <InputContainer
              label="Supplier Name"
              labelField="Name"
              list={supplierNameList}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'SupplierId'
                );
              }}
              optionName='Choose Supplier Name'
              type="select"
              value={selectedVouchers?.SupplierId}
              valueField="Id"
            />
            <InputContainer
              label="To Whom"
              labelField="ToWhom"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ToWhom'
                );
              }}
              type="text"
              value={selectedVouchers?.ToWhom}
            />
            <InputContainer
              label="Remarks"
              labelField="Remarks"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Remarks'
                );
              }}
              type="text"
              value={selectedVouchers?.Remarks}
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Information"
      />
    </>
  )
}